const REASONING_TITLE_REGEX = /\*\*(.+?)\*\*/s;

export type ReasoningPreview = {
  preview: string;
  continuation: string;
  hasOverflow: boolean;
};

export const getReasoningPreview = (reasoningMessage: string): ReasoningPreview => {
  const full = reasoningMessage.trim();
  if (!full) {
    return { preview: '', continuation: '', hasOverflow: false };
  }

  const titleMatch = REASONING_TITLE_REGEX.exec(full);
  if (titleMatch?.[0]) {
    const titleToken = titleMatch[0];
    const titleStart = titleMatch.index;
    const titleEnd = titleStart + titleToken.length;
    const beforeTitle = full.slice(0, titleStart).trim();
    const afterTitle = full.slice(titleEnd).trim();
    const continuation = [beforeTitle, afterTitle].filter(Boolean).join('\n').trim();

    return {
      preview: titleToken,
      continuation,
      hasOverflow: continuation.length > 0,
    };
  }

  const firstNonEmptyLine = full.split('\n').find((line) => line.trim().length > 0) ?? '';
  if (!firstNonEmptyLine) {
    return { preview: '', continuation: '', hasOverflow: false };
  }

  const lineIndex = full.indexOf(firstNonEmptyLine);
  const beforeLine = full.slice(0, lineIndex).trim();
  const afterLine = full.slice(lineIndex + firstNonEmptyLine.length).trim();
  const continuation = [beforeLine, afterLine].filter(Boolean).join('\n').trim();

  return {
    preview: firstNonEmptyLine,
    continuation,
    hasOverflow: continuation.length > 0,
  };
};
